import { createFileRoute } from "@tanstack/react-router";
import z from "zod";
import { FormBuilderPanel } from "@/features/form-editor/components/form-builder/form-builder-panel";

export const Route = createFileRoute(
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/jobTypes/$jobTypeId/full/form/",
)({
	component: OrgJobTypeFullFormBuilderRoute,
	params: {
		parse: (raw) => {
			const p = raw as { orgId: string; jobTypeId: string };
			return {
				orgId: z.string().parse(p.orgId),
				jobTypeId: z.string().parse(p.jobTypeId),
			};
		},
	},
});

function OrgJobTypeFullFormBuilderRoute() {
	return (
		<div className="flex min-h-[min(70vh,720px)] min-h-0 flex-1 flex-col px-4">
			<FormBuilderPanel />
		</div>
	);
}
